import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import CrashMessageComponent from '../components/crash-message/crash-message.jsx';
import log from '../lib/log.js';
import {recommendedBrowser} from '../lib/supported-browser';

// import {invokeLogin} from '../lib/services/postmessage';
// import {
//     clearUserinfo
// } from '../lib/services/query-params';
import errorMsg from '../lib/errorMsg';
class ErrorBoundary extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            hasError: false,
            errorId: null
        };
    }

    componentDidCatch (error, info) {
        // Error object may be undefined (IE?)
        let errorObject = this.props.error || {};

        while (errorObject instanceof Array) {
            errorObject = errorObject[0];
        }
        if (!errorObject) errorObject = {};
        error = error || {
            stack: errorMsg.ERROR_UNKNOWN,
            message: errorMsg.ERROR_UNKNOWN
        };
        
        if (errorObject.code === 'ECONNABORTED') {
            errorObject.message = errorMsg.ECONNABORTED;
        }

        if (errorObject.message === 'Network Error') {
            errorObject.message = errorMsg.NETWORK_ERROR;
        }
        
        if (errorObject.status === 401){
            // clearUserinfo();
            // invokeLogin();
            errorObject.message = errorMsg.TOKEN_EXPIRED;
        } else if (recommendedBrowser() && window.Sentry) {
            window.Sentry.withScope(scope => {
                Object.keys(info).forEach(key => {
                    scope.setExtra(key, info[key]);
                });
                scope.setExtra('action', this.props.action);
                window.Sentry.captureException(error);
            });
        }
        const errMsg = errorObject.message || errorObject.statusText || error.message;
        const errCode = errorObject.status || errorObject.code || errorObject.errCode || errorObject.errorCode || '未知';
        // Display fallback UI
        this.setState({
            hasError: true,
            errorId: window.Sentry ? window.Sentry.lastEventId() : null,
            errMsg: '错误码：' + errCode + '，错误信息：' + errMsg
        });

        // Log error locally for debugging as well.
        log.error(`Unhandled Error: ${error.stack}\nComponent stack: ${info.componentStack}`);
    }

    handleBack () {
        window.history.back();
    }

    handleReload () {
        window.location.reload();
    }

    render () {
        if (this.state.hasError) {
            if (recommendedBrowser()) {
                return (
                    <CrashMessageComponent
                        eventId={this.state.errorId}
                        onReload={this.handleReload}
                        errMsg={this.state.errMsg}
                    />
                );
            }
            return (<BrowserModalComponent
                error
                isRtl={this.props.isRtl}
                onBack={this.handleBack}
            />);
        }
        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    action: PropTypes.string.isRequired, // Used for defining tracking action
    children: PropTypes.node,
    isRtl: PropTypes.bool
};

const mapStateToProps = state => ({
    isRtl: state.locales.isRtl,
    error: state.scratchGui.projectState.error,
});

// no-op function to prevent dispatch prop being passed to component
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
